/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const FILE_SIZE_TABLE_STRINGS = {
  bandwidth: 'Bandwidth',
  fileSize: 'File size',
  heading: '50 largest files',
  requests: 'Requests',
};
